import { ENDTCODE_INIT_SUCCESS, ENDTCODE_INIT_FAIL, ENDTCODE_INIT_LOADING, CANCELCODE_INIT_LOADING, CANCELCODE_INIT_SUCCESS, CANCELCODE_INIT_FAIL,
  GIROBANK_INIT_LOADING, GIROBANK_INIT_SUCCESS, GIROBANK_INIT_FAIL } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // API menu
  menu: {},
  cancelCode: {
    init: 0,
    initErr: [],
    menu: {}
  },
  giroBank: {
    init: 0,
    initErr: [],
    menu: {}
  }
}

const getters = {
}

const mutations = {
  [ENDTCODE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [ENDTCODE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [ENDTCODE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [CANCELCODE_INIT_LOADING](state) {
    state.cancelCode.init = 0
    state.cancelCode.menu = {}
    state.cancelCode.initErr = []
  },
  [CANCELCODE_INIT_SUCCESS](state, data) {
    state.cancelCode.init = 1
    state.cancelCode.menu = data ? data.menu : null
    state.cancelCode.initErr = []
  },
  [CANCELCODE_INIT_FAIL](state, err) {
    state.cancelCode.init = 2
    state.cancelCode.menu = {}
    state.cancelCode.initErr = err
  },
  [GIROBANK_INIT_LOADING](state) {
    state.giroBank.init = 0
    state.giroBank.menu = {}
    state.giroBank.initErr = []
  },
  [GIROBANK_INIT_SUCCESS](state, data) {
    state.giroBank.init = 1
    state.giroBank.menu = data ? data.menu : null
    state.giroBank.initErr = []
  },
  [GIROBANK_INIT_FAIL](state, err) {
    state.giroBank.init = 2
    state.giroBank.menu = {}
    state.giroBank.initErr = err
  }
}

const actions = {
  async endtCodeManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.endtCodeManagement
    commit(ENDTCODE_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(ENDTCODE_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(ENDTCODE_INIT_FAIL, extractMessages(error))
      }
    }
  },
  async cancelCodeInit({ commit, rootState }) {
    const apiUrl = rootState.endtCode.menu.initCancelCode
    commit(CANCELCODE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(CANCELCODE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(CANCELCODE_INIT_FAIL, extractMessages(error))
    }
  },
  async giroBankInit({ commit, rootState }) {
    const apiUrl = rootState.endtCode.menu.initGiroBank
    commit(GIROBANK_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(GIROBANK_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(GIROBANK_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
